import React from 'react';
import { Group } from 'react-konva';
import type { Node } from '../../../core/models/scene';
import { useViewRules } from '../hooks/useViewRules';
import { DisplayRuleLabels } from './DisplayRuleLabel';

interface OrgDisplayRuleLabelsOverlayProps {
  nodes: Node[];
}

export const OrgDisplayRuleLabelsOverlay: React.FC<OrgDisplayRuleLabelsOverlayProps> = ({
  nodes,
}) => {
  const { getNodeStyle, isNodeVisible } = useViewRules();

  const labelNodes = React.useMemo(() => nodes.filter((node) => {
    if (!String(node.type ?? '').startsWith('org_')) return false;
    if (!isNodeVisible(node.id)) return false;
    return getNodeStyle(node.id).labels.length > 0;
  }), [getNodeStyle, isNodeVisible, nodes]);

  if (labelNodes.length === 0) return null;

  return (
    <>
      {labelNodes.map((node) => {
        const style = getNodeStyle(node.id);
        const width = (node.w ?? node.width ?? 180) as number;
        const height = (node.h ?? node.height ?? 80) as number;
        if (style.labels.length === 0) return null;

        return (
          <Group
            key={`org-label-overlay-${node.id}`}
            x={node.x}
            y={node.y}
            listening={false}
          >
            <DisplayRuleLabels
              labels={style.labels}
              nodeWidth={width}
              nodeHeight={height}
            />
          </Group>
        );
      })}
    </>
  );
};
